import { render, staticRenderFns } from "./SlideOptions.vue?vue&type=template&id=823bf87e&scoped=true"
import script from "./SlideOptions.vue?vue&type=script&lang=ts"
export * from "./SlideOptions.vue?vue&type=script&lang=ts"
import style0 from "./SlideOptions.vue?vue&type=style&index=0&id=823bf87e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823bf87e",
  null
  
)

export default component.exports